// extracted by mini-css-extract-plugin
module.exports = {"header":"MainNavigation_header__32GUL","logo":"MainNavigation_logo__2oXgp"};